import {
  GLOBAL_NOTIFICATION_DISMISSED,
  GLOBAL_NOTIFICATION_REQUEST,
} from './GlobalNotificationActionType';

export const dismissNotification = () => async (dispatch) => {
  dispatch({
    type: GLOBAL_NOTIFICATION_DISMISSED,
  });
};

export const notify = ({ type, message }) => async (dispatch) => {
  dispatch({
    type: GLOBAL_NOTIFICATION_REQUEST,
    payload: {
      type,
      message,
    },
  });
};

export const notifyInfo = (message) => async (dispatch) => {
  notify({ type: 'info', message })(dispatch);
};

export const notifySuccess = (message) => async (dispatch) => {
  notify({ type: 'success', message })(dispatch);
};

export const notifyWarning = (message) => async (dispatch) => {
  notify({ type: 'warning', message })(dispatch);
};

export const notifyError = (message) => async (dispatch) => {
  notify({ type: 'error', message })(dispatch);
};
